


























































import Vue from 'vue';
import * as enteSanitarioApi from '../../services/ente-sanitario-api';
import { EnteSanitarioEditViewModel } from '../../types';
import validationRulesMixin from '../../components/mixin/validation-rules-mixin';

export default Vue.extend({
    mixins: [validationRulesMixin],

    components: {},
    props: {
        id: { default: 0 },
        fullSize: { default: false },
    },
    data(): EnteSanitarioEditViewModel {
        return {
            item: null,
            isValid: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await enteSanitarioApi.getByKey(id);
            } else {
                this.setNewItem();
            }
        },
        close() {
            this.$emit('close');
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await enteSanitarioApi.create({
                    descrizione: this.item.descrizione,
                });
            } else {
                response = await enteSanitarioApi.update({
                    id: this.item.id,
                    version: this.item.version,
                    descrizione: this.item.descrizione,
                    attivo: this.item.attivo,
                });
            }
            await this.loadData(response.id);
            this.$emit('save', this.item);
        },
        setNewItem() {
            this.item = {
                id: 0,
                version: 0,
                descrizione: '',
                attivo: true,
                displayName: this.$i18n.t('labels.nuovo').toString(),
            };
        },
    },
    async mounted() {
        await this.loadData(this.id);
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
});
